import React, { useState, useEffect } from "react";
import { Modal,Image } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CgAttachment } from "react-icons/cg";
import "./input-component.css";
import { UploadOutlined  } from "@ant-design/icons";
import { FilePath } from "../../components/CommonSection/apiresources";

const DocumentUpload = ({
  imageSrc,
  inputRef,
  handleFileChange,
  onClickHandler,
  isCircle = false,
  label = "",
  isMandatory = false,
  disableStyle = true,
  images = [],
  onImagesSorted,
  attachment,
  isViewDoc = false,
  iwidth="",
  iheight="",
  readonly=false,
  setImages,
  fileIcon,
}) => {
  const [uploadState, setUploadState] = useState(images);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [draggedIndex, setDraggedIndex] = useState(null);

  useEffect(() => {
    setUploadState(images);
  }, [images]);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragEnd = (index) => {
    if (draggedIndex !== null && draggedIndex !== index) {
      const reorderedImages = [...uploadState];
      const [removed] = reorderedImages.splice(draggedIndex, 1);
      reorderedImages.splice(index, 0, removed);
      setUploadState(reorderedImages);
      if (onImagesSorted) onImagesSorted(reorderedImages);
    }
    setDraggedIndex(null);
  };

  const handleDragOver = (index, e) => {
    e.preventDefault();
  };

  const handleDrop = (index) => {
    if (draggedIndex !== null && draggedIndex !== index) {
      const reorderedImages = [...uploadState];
      const [removed] = reorderedImages.splice(draggedIndex, 1);
      reorderedImages.splice(index, 0, removed);
      setUploadState(reorderedImages);
      if (onImagesSorted) onImagesSorted(reorderedImages);
    }
    setDraggedIndex(null);
  };

 const removeImage = (index) => {
  const updatedImages = uploadState.filter((_, i) => i !== index);
  setUploadState(updatedImages);

  // Support both ways of syncing to parent
  if (onImagesSorted) {
    onImagesSorted(updatedImages);
  } else if (typeof setImages === "function") {
    setImages(updatedImages);
  }
};

const renderFilePreview = (file, index) => {
  const fileName = file?.fileName || file?.src?.split("/")?.pop();  // <-- Updated line
  const fileUrl = file.src?.startsWith("http") ? file.src : FilePath + file.src;

  // ✅ If fileIcon mode is enabled, show icon + name only (no preview)
  if (fileIcon) {
    const isPDF = /\.pdf$/i.test(fileName);
    const isDoc = /\.(doc|docx)$/i.test(fileName);
    const isImage = /\.(jpeg|jpg|png|gif)$/i.test(fileName);

    const icon = isPDF
      ? "📄 PDF"
      : isDoc
      ? "📄 DOC"
      : isImage
      ? "🖼️ IMG"
      : "📎 FILE";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span>{icon}</span>
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px" }}>
          {fileName}
        </a>
      </div>
    );
  }

  // Default rendering (full preview)
  const isImage = /\.(jpeg|jpg|png|gif)$/i.test(file.src);
  const isPDF = /\.pdf$/i.test(file.src);
  const isDoc = /\.(doc|docx)$/i.test(file.src);

  if (isImage) {
    return (
      <Image
        src={fileUrl}
        alt={`Image ${index + 1}`}
        preview={false}
        onClick={(e) => {
          e.stopPropagation();
          openModal(index);
        }}
        className="thumbnail-image"
        style={{ width: "100px", height: "100px", cursor: "pointer" }}
      />
    );
  }

  if (isPDF) {
    return (
      <iframe
        src={fileUrl + "#toolbar=1"}
        title="PDF Preview"
        style={{
          width: iwidth || "300px",
          height: iheight || "300px",
          border: "1px solid #ddd",
        }}
      />
    );
  }

  if (isDoc) {
    return (
      <iframe
        src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
        title="DOC Preview"
        style={{
          width: "450px",
          height: "400px",
          border: "1px solid #ddd",
        }}
      />
    );
  }

  return (
    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
      📎 {fileName}
    </a>
  );
};


  return (
    <div className={attachment === undefined ? "upload-container" : ""} style={{ margin: label === "" ? "0px" : "20px 10px" }}>
      {attachment === undefined && (
        <label className="upload-label">
          {label === null ? "" : "Upload Image"} {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      )}

      <div
        className={
          attachment === undefined
            ? `upload-box ${disableStyle ? "" : "custom-disabled-style"} ${isCircle ? "circle-shape" : ""}`
            : ""
        }
        onClick={readonly ? undefined : (onClickHandler || (() => inputRef.current?.click()))}
        style={{ cursor: readonly ? "not-allowed" : (disableStyle ? "pointer" : "not-allowed") }}
        onDragOver={(e) => e.preventDefault()}
 onDrop={(e) => {
  e.preventDefault();
  if (readonly) return;

  const dt = new DataTransfer();
  Array.from(e.dataTransfer.files).forEach(file => dt.items.add(file));

  const fakeEvent = {
    target: {
      files: dt.files
    }
  };

  handleFileChange(fakeEvent, null); // ✅ Call your function here
}}

      >
        <div className="upload-content" style={{ float: attachment ? "right" : "none" }}>
          {imageSrc ? (
            <div>
            <img
              src={imageSrc}
              alt="Uploaded Preview"
              className={`uploaded-image ${isCircle ? "circle-image" : ""}`}
            />
            </div>
          ) : (
            <>
              {attachment ? (
                <CgAttachment title="Attachment" className="upload-icon" />
              ) : (
                <>
                  <UploadOutlined  title="Upload Document" className="upload-icon" />
                  <span>Click to upload</span>
                  <span className="supported-files">Files supported: JPG, PNG, PDF, DOC</span>
                </>
              )}
            </>
          )}
        </div>
        <input
          ref={inputRef}
          type="file"
          onChange={handleFileChange}
          className="upload-input"
          name="upload"
          hidden
          multiple
          disabled={readonly ||!disableStyle}
        />
      </div>

      {uploadState.length > 0 && (
        <div className="mt-3" style={{ background: "white" }}>
          {uploadState.map((file, index) => (
           <div
  key={index}
  draggable={!readonly}
  onDragStart={() => handleDragStart(index)}
  onDragEnd={() => handleDragEnd(index)}
  onDragOver={(e) => handleDragOver(index, e)}
  onDrop={() => handleDrop(index)}
  style={{
    margin: fileIcon ? "5px 0" : "10px",
    cursor: fileIcon ? "default" : "move",
    display: fileIcon ? "block" : "inline-block",
    position: "relative",
  }}
>
  {renderFilePreview(file, index)}

  {!readonly && (
    <CloseOutlined
      onClick={(e) => {
        e.stopPropagation();
        removeImage(index);
      }}
      style={{
        position: "absolute",
        top: fileIcon ? "0px" : "5px",
        right: "5px",
        background: "#f0f0f0",
        borderRadius: "50%",
        cursor: "pointer",
      }}
    />
  )}

  {!fileIcon && (
    <div style={{ textAlign: 'center', marginTop: '5px', fontSize: '12px', fontWeight: 500 }}>
      {index + 1}
    </div>
  )}
</div>

          ))}

          {/* Image Modal */}
          <Modal visible={isModalOpen} onCancel={closeModal} footer={null} width={600}>
            <div className="modal-content">
             
              <div className="main-image-container" style={{overflow: "auto",maxHeight: "80vh",textAlign: "center"}}>
                <Image
                  src={uploadState[currentImageIndex]?.src}
                  alt={`Preview ${currentImageIndex + 1}`}
                  preview={true}
                  className="main-image"
                  width={400}
                  height={400}
                 
                />

              </div>
              <div className="modal-thumbnail-gallery">
                {uploadState
                  .filter((file) => /\.(jpeg|jpg|png|gif)$/i.test(file.src))
                  .map((img, i) => (
                    <img
                      key={i}
                      src={img.src}
                      alt={`Thumbnail ${i + 1}`}
                      onClick={() => {
                        setCurrentImageIndex(i);
                      }}
                      className={`modal-thumbnail ${i === currentImageIndex ? "active-thumbnail" : ""}`}
                      style={{ width: "100px", height: "100px", cursor: "pointer" }}
                    />
                  ))}
              </div>
            </div>
          </Modal>

        </div>
      )}
    </div>
  );
};

export default DocumentUpload;
